import React, { useContext, useEffect } from 'react'
import Navbar from '../navbar'
import Table from '../table'
import Images from '../../img'
import { store } from '../../store'
import { Link } from 'react-router-dom'

function Mainpage(){
    const { state, dispatch } = useContext(store)
    const { email } = state.user
    
    useEffect(()=>{
        let emailTemp;
        email === '' ? emailTemp = localStorage.getItem('account') : emailTemp = email
        dispatch({
            type: 'USER_SIGNIN',
            email: emailTemp
        })
    },[dispatch,email])
    
    return (
        <div>
            <Navbar/>
            <div className="row">
                <div style={{ backgroundColor: "#36424A", height: "92vh" }} className="col-2 pr-0">
                    <div className="row mb-5">
                        <div className="col-12">
                            <div className="mx-auto mt-3" style={{ background: `url('${Images.photopp}')`, backgroundSize: "160%",backgroundPosition:"-40px -10px",backgroundRepeat: "no-repeat", height: '150px', width: '150px', borderRadius: "50%", border: "5px solid white" }}></div>
                            <span className="p-2 px-3" style={{ fontWeight: "bold", fontSize: "20px",borderRadius: "4%", backgroundColor: "white" }}>
                                { email }
                            </span>
                        </div>
                    </div>
                    <hr className="mb-0"/>
                    <Link to="/manage">
                        <button data-testid="manage-test" type="button" className="btn btn-primary btn-block"> 
                            <i className="fas fa-key mr-2" ></i>
                            Password Manager
                        </button>
                    </Link>
                </div>
                <div style={{ height: "92vh", backgroundColor: "white" }} className="col-10">
                    <Table />
                </div>
            </div>
        </div>
    )
}

export default Mainpage